export const cdcStaff = [
 
   
  {
    id: 3,
    name: "K Adisankara Narayana",
    designation: "Junior Assistant",
    phone: "9866685731",
    email: "kethamokkalaadi98@gmail.com"
  },
  {
    id: 4,
    name: "Dr. M Nagaraju",
    designation: "Office Assistant",
    phone: "9985817905",
    email: "mnraju1976@gmail.com"
  },
  {
    id: 5,
    name: "A Elisha",
    designation: "Office Assistant",
    phone: "9949806990",
    email: "avijaelisha143@gmail.com"
  },
  {
    id: 6,
    name: "C Nageswara Rao",
    designation: "Office Subordinate",
    phone: "9704041076",
    email: null
  }
];
